// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9454d123","455":"428018fd","977":"6c17e9b5"}[chunkId] + ".chunk.js";
};